import React, { forwardRef } from 'react';

import { BaseMenuOption } from 'src/editor/toolbars/menus/BaseMenuOption';
import type { CommonMenuItemProps } from 'src/editor/toolbars/menus/types';
import { ClientTransforms } from 'src/editor/transforms';
import { useCurrentUserId } from 'src/gql';
import { useAuthorizedTransforms } from 'src/hooks';
import { useEditor } from 'src/layout-engine';
import { useEditingMode } from 'src/store/document/selectors';

export const DeleteTableMenuItem = forwardRef(function DeleteTableMenuItem(
  props: CommonMenuItemProps,
  ref: React.Ref<HTMLLIElement>
): JSX.Element {
  const { closeRootMenu, ...rest } = props;
  const currentUserId = useCurrentUserId();
  const { editingMode } = useEditingMode();
  const editor = useEditor();
  const { AuthorizedTransforms } = useAuthorizedTransforms();

  function deleteTable(): void {
    if (!editingMode || !currentUserId) return closeRootMenu();

    AuthorizedTransforms.deleteTable(editor, { authorId: currentUserId, editingMode });
    ClientTransforms.focus(editor);
    closeRootMenu();
  }

  return <BaseMenuOption ref={ref} label={`Delete table`} onClick={deleteTable} {...rest} />;
});
